import { connect } from 'react-redux';
import HeatMap from '../../components/SingleCell/HeatMap';

const mapStateToProps = state => ({
  cellPopulation: state.cellPopulation,
});

export default connect(mapStateToProps)(HeatMap);



// WEBPACK FOOTER //
// ./src/containers/SingleCell/HeatMap.js